import { ErrorBoundary } from '@sentry/react';
import { QueryErrorResetBoundary, useQueryClient } from '@tanstack/react-query';
import { MiniErrorFallback } from './errors/mini';
import { ComponentType, ReactNode, Suspense } from 'react';
import { Loader } from './ui/loader';
import { ErrorFallbackProps } from '@/types/error-fallback-props';

type ErrorFrameProps = {
  children: ReactNode;
  ErrorFallback?: ComponentType<ErrorFallbackProps>;
  pendingFallback?: ReactNode;
};

export function ErrorFrame({
  children,
  ErrorFallback = MiniErrorFallback,
  pendingFallback = <Loader />,
}: ErrorFrameProps) {
  const queryClient = useQueryClient();

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={() => {
            reset();
            queryClient.invalidateQueries();
          }}
          fallback={({ error, resetError }) => <ErrorFallback error={error} resetError={resetError} />}
        >
          <Suspense fallback={pendingFallback}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
